import { useUserEventLogger } from '@repo/tracking-service';
import { useAuthContext } from '@repo/user-session';
import { CI_REQUEST_TYPES, CIPrepareDataForm, useCiHistoryController, usePrepareCiAuthData } from '@repo/user-sign';
import { Button, Title, TopNavigation } from '@zenterprise-inc/ui';
import cn from 'clsx';
import { useRouter } from 'next/router';
import { useState } from 'react';

import { ReasonSelectInput } from '@/components/auth/withdraw/ReasonSelectInput';
import s from '@/components/my/common/layout.module.scss';
import { AUTH_PATHS } from '@/lib/constants/paths';
import { WithdrawalReason } from '@/lib/types/auth';

export function ReasonContent() {
  const router = useRouter();
  const { authService } = useAuthContext();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { ciFormRef, prepareData, prepareCiAuthenticationData } = usePrepareCiAuthData(CI_REQUEST_TYPES.VERIFICATION, AUTH_PATHS.회원탈퇴확인);

  const [selectedReason, setSelectedReason] = useState<WithdrawalReason | null>(null);
  const [etcReason, setEtcReason] = useState('');
  const isEtc = selectedReason?.title?.includes('기타');
  useCiHistoryController('entry');

  const { sendClickEvent } = useUserEventLogger();

  const handleSubmit = async () => {
    if (!selectedReason || !authService) return;
    sendClickEvent('feedback-delete_body_reason-submit', {
      reason: selectedReason.title
    });
    setIsSubmitting(true);
    sessionStorage.setItem('withdraw-reason', JSON.stringify({ leaveReasonId: selectedReason.id, reason: isEtc ? etcReason : undefined }));
    try {
      await prepareCiAuthenticationData();
    } catch (error) {
      // CI 인증 준비 실패 시 세션스토리지 정리 및 버튼 활성화
      sessionStorage.removeItem('withdraw-reason');
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <TopNavigation.Basic leftIcon={'back'} onLeftClick={() => router.back()} className={s.nav_position} />
      <main className={cn(s.main_content, 'px-4.5')}>
        <article>
          <section>
            <Title.Headline
              title={'비즈넵 환급을 탈퇴하려는\n이유가 궁금해요'}
              subText={'고려하고 계신 이유를 알려주시면,\n더욱 나은 서비스를 위해 개선에 힘쓰겠습니다.'}
              size={'large'}
              className={'mb-2'}
            />

            <ReasonSelectInput title={selectedReason?.title || '이유를 선택해주세요'} setSelectedReason={setSelectedReason} />
            {isEtc && (
              <div>
                <Title.Section title={'기타 이유를 작성해주세요'} className={'mt-4'} size={'small'} />
                <textarea
                  value={etcReason}
                  className={cn(
                    s.scroll_hidden,
                    'h-[93px] py-3 px-4 w-full resize-none rounded-2.5 border border-gray-200 focus:outline-0 focus:border-gray-800 text-gray-800 sub-title-16 block'
                  )}
                  maxLength={100}
                  onChange={(e) => setEtcReason(e.target.value)}
                />
                <p className={'body-13 text-gray-600 my-1'}>{etcReason.length} / 100</p>
              </div>
            )}

            {(isEtc ? etcReason : selectedReason) && (
              <Button.StickyBottom.Wrapper className={'px-4.5'}>
                <Button.StickyBottom.Button type={'button'} state={'primary'} onClick={handleSubmit} disabled={isSubmitting}>
                  의견 제출하기
                </Button.StickyBottom.Button>
              </Button.StickyBottom.Wrapper>
            )}
          </section>
        </article>
      </main>
      <CIPrepareDataForm ciFormRef={ciFormRef} prepareData={prepareData} />
    </>
  );
}
